import { render, staticRenderFns } from "./PopupAddClinic.vue?vue&type=template&id=38f2dd58&"
import script from "./PopupAddClinic.vue?vue&type=script&lang=ts&"
export * from "./PopupAddClinic.vue?vue&type=script&lang=ts&"
import style0 from "./PopupAddClinic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports